import { MeasurementSystem } from '../types';

const YARDS_TO_METERS = 0.9144;
const MPH_TO_KMH = 1.60934;
const FEET_TO_METERS = 0.3048;

export const toDisplayDistance = (yards: number, measurementSystem: MeasurementSystem): number =>
  measurementSystem === 'metric' ? yards * YARDS_TO_METERS : yards;

export const toCanonicalDistanceYards = (displayDistance: number, measurementSystem: MeasurementSystem): number =>
  measurementSystem === 'metric' ? displayDistance / YARDS_TO_METERS : displayDistance;

export const toDisplaySpeed = (mph: number, measurementSystem: MeasurementSystem): number =>
  measurementSystem === 'metric' ? mph * MPH_TO_KMH : mph;

export const toCanonicalSpeedMph = (displaySpeed: number, measurementSystem: MeasurementSystem): number =>
  measurementSystem === 'metric' ? displaySpeed / MPH_TO_KMH : displaySpeed;

export const toDisplayHeight = (feet: number, measurementSystem: MeasurementSystem): number =>
  measurementSystem === 'metric' ? feet * FEET_TO_METERS : feet;

export const toCanonicalHeightFeet = (displayHeight: number, measurementSystem: MeasurementSystem): number =>
  measurementSystem === 'metric' ? displayHeight / FEET_TO_METERS : displayHeight;

export const distanceUnitLabel = (measurementSystem: MeasurementSystem): string =>
  measurementSystem === 'metric' ? 'm' : 'yds';

export const speedUnitLabel = (measurementSystem: MeasurementSystem): string =>
  measurementSystem === 'metric' ? 'km/h' : 'mph';

export const heightUnitLabel = (measurementSystem: MeasurementSystem): string =>
  measurementSystem === 'metric' ? 'm' : 'ft';
